/* ============================================================================
FILE: po-katupirsia9-mois-posoennoiaux-texts-fr-en-es-20260327.js
MODE: protected trilingual with FR / EN / ES buttons + canonical lexicon preserved
API:  window.PoKatupirsia9MoisPosoennoiauxTextsFR_EN_ES_20260327
ROOT: .po-axis-section[data-po-axis='mois_posoennoiaux']
ROLE:
  - Langue pilotée par localStorage : po_lex_lang + goody_gp_lang
  - Ré-injecte le contenu FR / EN / ES dans les slots
  - Maintient les entrées canoniques en français, y compris via protection fine
  - Ajoute une lecture audio générale et locale par bloc
  - N’altère ni l’architecture HTML, ni le nom du fichier, ni la logique de base
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_KATUPIRSIA9_MOIS_POSOENNOIAUX_TEXTS_20260327__) return;
  window.__PO_KATUPIRSIA9_MOIS_POSOENNOIAUX_TEXTS_20260327__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = ".po-axis-section[data-po-axis='mois_posoennoiaux']";

  var CONCEPT_URL  = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Mois_posoennoiaux_conceptuel.png?v=1773266995";
  var FUNCTION_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Mois_posoennoiaux_fonctionnel.png?v=1773266995";

  var CANON = {
    title: "Mois posœnnoïaux",
    singular: "Mois posœnnoïal",
    annee: "Année posœnnoïale",
    saison: "Saison posœnnoïale",
    decade: "Décade",
    numeris: "Numéris",
    humanus: "Humanus",
    souffle: "Souffle d’Or",
    triade: "3–6–9",
    ap: "AP",
    manuscrit: "Katûpirsia 9 — Âṣẹxel’Or",
    months: [
      "Katûgerminis",
      "Katûluxôr",
      "Katûvýská",
      "Katûsekhemty",
      "Katûnyamedua",
      "Katûintiraymi",
      "Katûqhanaegis",
      "Katûuttara",
      "Katûkhyāna",
      "Katûlufah",
      "Katûparnauras",
      "Katûdrabšolis"
    ]
  };

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (s === "fr" || s.indexOf("fr") === 0) return "fr";
    if (s === "en" || s.indexOf("en") === 0) return "en";
    if (s === "es" || s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "es";
    return "fr";
  }

  function readStoredLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    return v ? normLang(v) : "";
  }

  function getBrowserLang(){
    var dl = document && document.documentElement ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    if (typeof navigator !== "undefined"){
      if (navigator.languages && navigator.languages.length) return normLang(navigator.languages[0] || "fr");
      if (navigator.language) return normLang(navigator.language || "fr");
    }
    return "fr";
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, l); }catch(_e){}
    try{ document.documentElement.setAttribute("lang", l); }catch(__e){}
    return l;
  }

  function getLang(){
    return readStoredLang() || getBrowserLang() || "fr";
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function getTargetBlocks(){
    return Array.prototype.slice.call(document.querySelectorAll(ROOT_SEL) || []);
  }

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var k = String(v || "");
    if (!k || seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"), seen);
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"), seen);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, "’"), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, "’"), seen);

    if (t.indexOf("/") !== -1){
      var parts = t.split("/");
      for (var i=0;i<parts.length;i++){
        var p = clampStr(parts[i]).trim();
        if (!p) continue;
        var vars = buildVariants(p);
        for (var j=0;j<vars.length;j++) uniqPush(out, vars[j], seen);
      }
    }
    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta &&
         Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)){
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)){
        return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
      }
    }catch(e){}

    return [
      "Posœnnoïsme",
      "Katûpirsia",
      CANON.title,
      CANON.singular,
      CANON.annee,
      CANON.saison,
      CANON.decade,
      CANON.numeris,
      CANON.humanus,
      CANON.souffle,
      CANON.ap,
      CANON.manuscrit,
      CANON.triade,
      "Àṣẹxel’Or"
    ].concat(CANON.months);
  }

  function buildProtectRegexFromSimplified(){
    var base = getSimplifiedLexiqueFRList();
    var terms = [];
    var seen = Object.create(null);
    var extras = [
      CANON.title,
      CANON.singular,
      CANON.annee,
      CANON.saison,
      CANON.decade,
      CANON.numeris,
      CANON.humanus,
      CANON.souffle,
      CANON.triade,
      CANON.ap,
      CANON.manuscrit,
      "Katûpirsia 9",
      "Âṣẹxel’Or"
    ].concat(CANON.months);

    var all = base.concat(extras);
    for (var i=0;i<all.length;i++){
      var vars = buildVariants(all[i]);
      for (var j=0;j<vars.length;j++) uniqPush(terms, vars[j], seen);
    }

    terms.sort(function(a,b){ return b.length - a.length; });

    var parts = [];
    for (var k=0;k<terms.length;k++) parts.push(escapeRegExp(terms[k]));
    if (!parts.length) return null;

    try{ return new RegExp("(" + parts.join("|") + ")", "g"); }
    catch(e){ return null; }
  }

  var __PO_PROTECT_CACHE__ = { key:"", re:null };

  function ensureProtectEngineReady(){
    var key = "fallback";
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        key = "meta:" + window.PO_LEXICON_META.lexique_simplifie_fr.length;
      }else if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        key = "meta2:" + window.PO_LEXICON.meta.lexique_simplifie_fr.length;
      }
    }catch(e){ key = "fallback"; }

    if (__PO_PROTECT_CACHE__.key === key && __PO_PROTECT_CACHE__.re) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectRegexFromSimplified();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute("translate");
    if (tr && String(tr).toLowerCase() === "no") return true;
    var cls = el.className || "";
    if (typeof cls === "string"){
      if (cls.indexOf("notranslate") !== -1) return true;
      if (cls.indexOf("po-lex-protect") !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch);
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;

    var txt = textNode.nodeValue;
    if (!txt) return;

    re.lastIndex = 0;
    if (!re.test(txt)) return;

    re.lastIndex = 0;
    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;

    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var match = m[0];
      var end = start + match.length;

      if (start > last) frag.appendChild(doc.createTextNode(txt.slice(last, start)));

      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : "";
      if (chPrev && isWordLikeChar(chPrev)) frag.appendChild(doc.createTextNode(" "));

      var span = doc.createElement("span");
      span.setAttribute("translate", "no");
      span.className = "po-lex-protect notranslate";
      span.textContent = match;
      frag.appendChild(span);

      var chNext = (end < txt.length) ? txt.charAt(end) : "";
      if (chNext && isWordLikeChar(chNext)) frag.appendChild(doc.createTextNode(" "));

      last = end;
      if (match.length === 0) break;
    }

    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsInElement(el){
    if (!el || !el.querySelectorAll) return;
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return;

    var walker;
    try{
      walker = document.createTreeWalker(
        el,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            var p = n.parentNode;
            var pn = p && p.nodeName ? p.nodeName : "";
            if (pn === "SCRIPT" || pn === "STYLE") return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return; }

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
  }

  function protectKeywordsHTML(html){
    if (!html) return "";
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return String(html);

    var tpl = document.createElement("template");
    tpl.innerHTML = String(html);
    var root = tpl.content || tpl;

    var walker;
    try{
      walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return String(html); }

    var nodes = [];
    var t;
    while ((t = walker.nextNode())) nodes.push(t);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
    return tpl.innerHTML;
  }

  function htmlParagraphize(txt){
    var s = clampStr(txt);
    if (!s) return "";
    return "<p>" + escapeHTML(s).replace(/\n+/g, "</p><p>") + "</p>";
  }

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(clampStr(html));
    protectKeywordsInElement(el);
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    var s = clampStr(src);
    var a = clampStr(alt);
    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt", ""); }catch(_e){}
      try{ el.style.display = "none"; }catch(__e){}
      return;
    }
    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(_e){}
    try{ el.style.display = ""; }catch(__e){}
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++) out.push("<li>" + protectKeywordsHTML(escapeHTML(arr[i])) + "</li>");
    el.innerHTML = out.join("");
    protectKeywordsInElement(el);
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      var h = protectKeywordsHTML(escapeHTML(b.head || ""));
      var t = protectKeywordsHTML(clampStr(b.text || ""));
      out.push('<div class="po-axis-wb"><div class="po-axis-wb__h">' + h + '</div><div class="po-axis-wb__t">' + t + '</div></div>');
    }
    host.innerHTML = out.join("");
    protectKeywordsInElement(host);
  }

  var FALLBACK = {
    fr: {
      title: CANON.title,
      kicker: "Extrait de <em>Katûpirsia&nbsp;9 — Âṣẹxel’Or</em><br />(Architecture mensuelle du vrai temps, archétypes, nombres-guides et souffle majeur)",
      h_def: "Définition opérative",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Dans l’<span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span>, les <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span> constituent des unités de 30 jours (3 décades) : le souffle majeur du cycle.",
      def_long:
        "<p>Le lexique définit le <span class=\"notranslate\" translate=\"no\">Mois posœnnoïal</span> comme une unité de structure : <strong>30 jours = 3 décades</strong>. Sa fonction est de donner un souffle majeur : installer un archétype, orienter une pratique et rendre la transformation transmissible.</p>" +
        "<p>Dans le manuscrit de <span class=\"notranslate\" translate=\"no\">Katûpirsia 9 — Âṣẹxel’Or</span>, trois décades composent un mois de trente jours, spirale miniature de l’année. La première décade initie et prépare, la deuxième développe et stabilise, la troisième accomplit et ouvre vers la transmutation.</p>" +
        "<p>Chaque mois porte un archétype, un nombre-guide et une phrase vibratoire ; il s’accompagne de pratiques propres — méditations, accords, œuvres créatives. Vivre le mois revient à habiter un archétype et à installer une tenue de conscience dans une durée praticable.</p>" +
        "<p>Les <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span> reproduisent ainsi la respiration universelle : inspiration, expansion, expiration. Ils condensent la logique annuelle dans un cycle réduit, jusqu’à faire de chaque mois un miroir cosmique, une variation archétypale et un organe du vrai temps.</p>",
      h_features: "Dynamiques opératives",
      h_questions: "Applications / repères",
      hint_fold: "déplier",
      h_family: "Liens systémiques",
      h_wordbuild: "Construction du terme",
      features: [
        "Unité temporelle : 30 jours = 3 décades.",
        "Souffle majeur : le mois donne au cycle une amplitude praticable et transmissible.",
        "Triphasage canonique : initier, développer / stabiliser, accomplir / transmuter.",
        "Archétype mensuel : chaque mois porte un nombre-guide, une phrase vibratoire et des pratiques propres.",
        "Miroir de l’année : le mois condense la logique annuelle dans un cycle réduit."
      ],
      questions: [
        "Dans quelle décade du mois suis-je : initier, stabiliser ou transmuter ?",
        "Quel réglage minimal installe ici la tenue du mois : cadence, attention, cadre ou densité ?",
        "Quel archétype est activé dans ce moment du cycle ?",
        "Quelle pratique, quelle œuvre ou quelle phrase brève vérifie la cohérence du mois ?"
      ],
      example_box: "<div><strong>Ex.</strong> Situer une création dans les <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span>, c’est demander quel archétype elle habite, dans quelle décade elle se trouve et quel acte bref en confirme la tenue.</div>",
      family_1: "<p><strong>Liens internes :</strong> la page traite l’ensemble des <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span>, tandis que le lexique décrit l’unité <span class=\"notranslate\" translate=\"no\">Mois posœnnoïal</span>. Cette unité est sous-entrée de <span class=\"notranslate\" translate=\"no\">AP</span> et se relie à <span class=\"notranslate\" translate=\"no\">Décade</span>, <span class=\"notranslate\" translate=\"no\">Saison posœnnoïale</span>, <span class=\"notranslate\" translate=\"no\">Numéris</span>, à la triade <span class=\"notranslate\" translate=\"no\">3–6–9</span>, à <span class=\"notranslate\" translate=\"no\">Humanus</span> et au <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span>.</p>",
      family_2: "<p><strong>Fonction systémique :</strong> dans l’<span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span>, le mois occupe le niveau du souffle majeur entre la décade et les épagomènes. Il sert d’organe cyclique : variation thématique, ascension spiralée, archétype incarné, respiration ample du temps vécu.</p>",
      word_blocks: [
        { head: "1) Mois", text: "Cycle intermédiaire, organe du temps, unité assez large pour installer une tenue et conduire une transformation." },
        { head: "2) posœnnoïaux", text: "Dans le corpus, le terme rattache ces mois au vrai temps : structure respirante, orientée par la logique <span class=\"notranslate\" translate=\"no\">3–6–9</span> et par l’architecture de <span class=\"notranslate\" translate=\"no\">AP</span>." },
        { head: "3) Ensemble", text: "Les <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span> forment la grande modulation de l’année : douze souffles majeurs, chacun porteur d’un archétype, d’un nombre-guide et d’une pratique." }
      ],
      word_notes: [
        "Le lexique emploie l’unité singulière « Mois posœnnoïal » ; la page retient le pluriel pour l’ensemble des douze mois.",
        "Deux idéogrammes attestés : conceptuel et fonctionnel.",
        "Fonction : donner un souffle majeur, orienter une pratique, rendre la transformation transmissible."
      ],
      cta_translate: "Proposer une traduction du concept"
    },
    en: {
      title: CANON.title,
      kicker: "Excerpt from <em>Katûpirsia&nbsp;9 — Âṣẹxel’Or</em><br />(Monthly architecture of true time, archetypes, guide-numbers, and major breath)",
      h_def: "Operative definition",
      chips: ["Concept ideogram", "Functional ideogram"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Within <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span>, the <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span> form 30-day units (3 decades): the cycle’s major breath.",
      def_long:
        "<p>The lexicon defines the <span class=\"notranslate\" translate=\"no\">Mois posœnnoïal</span> as a structural unit: <strong>30 days = 3 decades</strong>. Its function is to provide a major breath: install an archetype, orient a practice, and make transformation transmissible.</p>" +
        "<p>In the manuscript of <span class=\"notranslate\" translate=\"no\">Katûpirsia 9 — Âṣẹxel’Or</span>, three decades compose a thirty-day month, a miniature spiral of the year. The first decade initiates and prepares, the second develops and stabilizes, the third fulfills and opens toward transmutation.</p>" +
        "<p>Each month carries an archetype, a guide-number, and a vibratory phrase; it also comes with its own practices — meditations, accords, and creative works. To live the month is to inhabit an archetype and install a mode of consciousness within a practicable duration.</p>" +
        "<p>The <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span> thus reproduce universal respiration: inspiration, expansion, expiration. They condense the annual logic into a reduced cycle, turning every month into a cosmic mirror, an archetypal variation, and an organ of true time.</p>",
      h_features: "Operative dynamics",
      h_questions: "Applications / markers",
      hint_fold: "expand",
      h_family: "Systemic links",
      h_wordbuild: "Construction of the term",
      features: [
        "Temporal unit: 30 days = 3 decades.",
        "Major breath: the month gives the cycle a practicable and transmissible amplitude.",
        "Canonical triphasing: initiate, develop / stabilize, fulfill / transmute.",
        "Monthly archetype: each month carries a guide-number, a vibratory phrase, and specific practices.",
        "Mirror of the year: the month condenses the annual logic into a reduced cycle."
      ],
      questions: [
        "Which decade of the month am I in: initiate, stabilize, or transmute?",
        "Which minimal adjustment installs the month’s hold here: cadence, attention, frame, or density?",
        "Which archetype is active in this moment of the cycle?",
        "Which practice, work, or brief phrase verifies the month’s coherence?"
      ],
      example_box: "<div><strong>Ex.</strong> To place a creation within the <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span> is to ask which archetype it inhabits, which decade it belongs to, and which brief act confirms its hold.</div>",
      family_1: "<p><strong>Internal links:</strong> this page addresses the whole set of <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span>, while the lexicon describes the singular unit <span class=\"notranslate\" translate=\"no\">Mois posœnnoïal</span>. That unit is a sub-entry of <span class=\"notranslate\" translate=\"no\">AP</span> and connects with <span class=\"notranslate\" translate=\"no\">Décade</span>, <span class=\"notranslate\" translate=\"no\">Saison posœnnoïale</span>, <span class=\"notranslate\" translate=\"no\">Numéris</span>, the triad <span class=\"notranslate\" translate=\"no\">3–6–9</span>, <span class=\"notranslate\" translate=\"no\">Humanus</span>, and <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span>.</p>",
      family_2: "<p><strong>Systemic function:</strong> within <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span>, the month occupies the level of the major breath between the decade and the epagomenal days. It acts as a cyclic organ: thematic variation, spiral ascent, embodied archetype, and broad respiration of lived time.</p>",
      word_blocks: [
        { head: "1) Month", text: "Intermediate cycle, organ of time, a large enough unit to install a hold and conduct a transformation." },
        { head: "2) posœnnoïaux", text: "In the corpus, the term attaches these months to true time: a breathing structure oriented by the logic of <span class=\"notranslate\" translate=\"no\">3–6–9</span> and by the architecture of <span class=\"notranslate\" translate=\"no\">AP</span>." },
        { head: "3) Whole", text: "The <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span> form the year’s broad modulation: twelve major breaths, each carrying an archetype, a guide-number, and a practice." }
      ],
      word_notes: [
        "The lexicon uses the singular unit “Mois posœnnoïal”; this page retains the plural for the full set of twelve months.",
        "Two attested ideograms: conceptual and functional.",
        "Function: to provide a major breath, orient a practice, and make transformation transmissible."
      ],
      cta_translate: "Suggest a translation of the concept"
    },
    es: {
      title: CANON.title,
      kicker: "Extracto de <em>Katûpirsia&nbsp;9 — Âṣẹxel’Or</em><br />(Arquitectura mensual del tiempo verdadero, arquetipos, números-guía y aliento mayor)",
      h_def: "Definición operativa",
      chips: ["Ideograma conceptual", "Ideograma funcional"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Dentro de <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span>, los <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span> forman unidades de 30 días (3 décadas): el aliento mayor del ciclo.",
      def_long:
        "<p>El léxico define el <span class=\"notranslate\" translate=\"no\">Mois posœnnoïal</span> como una unidad de estructura: <strong>30 días = 3 décadas</strong>. Su función consiste en dar un aliento mayor: instalar un arquetipo, orientar una práctica y volver transmisible la transformación.</p>" +
        "<p>En el manuscrito de <span class=\"notranslate\" translate=\"no\">Katûpirsia 9 — Âṣẹxel’Or</span>, tres décadas componen un mes de treinta días, espiral miniatura del año. La primera década inicia y prepara, la segunda desarrolla y estabiliza, la tercera cumple y abre hacia la transmutación.</p>" +
        "<p>Cada mes lleva un arquetipo, un número-guía y una frase vibratoria; también se acompaña de prácticas propias — meditaciones, acuerdos y obras creativas. Vivir el mes consiste en habitar un arquetipo e instalar una tenencia de conciencia en una duración practicable.</p>" +
        "<p>Los <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span> reproducen así la respiración universal: inspiración, expansión, expiración. Condensan la lógica anual en un ciclo reducido, hasta hacer de cada mes un espejo cósmico, una variación arquetipal y un órgano del tiempo verdadero.</p>",
      h_features: "Dinámicas operativas",
      h_questions: "Aplicaciones / referencias",
      hint_fold: "desplegar",
      h_family: "Vínculos sistémicos",
      h_wordbuild: "Construcción del término",
      features: [
        "Unidad temporal: 30 días = 3 décadas.",
        "Aliento mayor: el mes da al ciclo una amplitud practicable y transmisible.",
        "Tripasaje canónico: iniciar, desarrollar / estabilizar, cumplir / transmutar.",
        "Arquetipo mensual: cada mes lleva un número-guía, una frase vibratoria y prácticas propias.",
        "Espejo del año: el mes condensa la lógica anual en un ciclo reducido."
      ],
      questions: [
        "¿En qué década del mes estoy: iniciar, estabilizar o transmutar?",
        "¿Qué ajuste mínimo instala aquí la tenencia del mes: cadencia, atención, marco o densidad?",
        "¿Qué arquetipo está activo en este momento del ciclo?",
        "¿Qué práctica, obra o frase breve verifica la coherencia del mes?"
      ],
      example_box: "<div><strong>Ej.</strong> Situar una creación dentro de los <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span> consiste en preguntar qué arquetipo habita, en qué década se encuentra y qué acto breve confirma su tenencia.</div>",
      family_1: "<p><strong>Vínculos internos:</strong> esta página trata el conjunto de los <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span>, mientras que el léxico describe la unidad singular <span class=\"notranslate\" translate=\"no\">Mois posœnnoïal</span>. Esa unidad es subentrada de <span class=\"notranslate\" translate=\"no\">AP</span> y se enlaza con <span class=\"notranslate\" translate=\"no\">Décade</span>, <span class=\"notranslate\" translate=\"no\">Saison posœnnoïale</span>, <span class=\"notranslate\" translate=\"no\">Numéris</span>, con la tríada <span class=\"notranslate\" translate=\"no\">3–6–9</span>, con <span class=\"notranslate\" translate=\"no\">Humanus</span> y con el <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span>.</p>",
      family_2: "<p><strong>Función sistémica:</strong> dentro de <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span>, el mes ocupa el nivel del aliento mayor entre la década y los días epagómenos. Actúa como un órgano cíclico: variación temática, ascensión en espiral, arquetipo encarnado y respiración amplia del tiempo vivido.</p>",
      word_blocks: [
        { head: "1) Mes", text: "Ciclo intermedio, órgano del tiempo, unidad lo bastante amplia para instalar una tenencia y conducir una transformación." },
        { head: "2) posœnnoïaux", text: "En el corpus, el término vincula estos meses al tiempo verdadero: estructura respirante orientada por la lógica <span class=\"notranslate\" translate=\"no\">3–6–9</span> y por la arquitectura de <span class=\"notranslate\" translate=\"no\">AP</span>." },
        { head: "3) Conjunto", text: "Los <span class=\"notranslate\" translate=\"no\">Mois posœnnoïaux</span> forman la gran modulación del año: doce alientos mayores, cada uno portador de un arquetipo, un número-guía y una práctica." }
      ],
      word_notes: [
        "El léxico usa la unidad singular “Mois posœnnoïal”; esta página retiene el plural para el conjunto de los doce meses.",
        "Dos ideogramas atestiguados: conceptual y funcional.",
        "Función: dar un aliento mayor, orientar una práctica y hacer transmisible la transformación."
      ],
      cta_translate: "Proponer una traducción del concepto"
    }
  };

  function fb(lang){ return FALLBACK[lang] || FALLBACK.fr; }

  function setPressed(root, lang){
    var btns = root.querySelectorAll('.po-langbtn');
    for (var i=0;i<btns.length;i++){
      var btnLang = normLang(btns[i].getAttribute('data-po-lang') || 'fr');
      btns[i].setAttribute('aria-pressed', btnLang === lang ? 'true' : 'false');
    }
  }

  function setCTA(root, lang){
    setSlotText(root, 'cta_translate', fb(lang).cta_translate);
  }

  function renderRoot(root, lang){
    var T = fb(lang);
    setSlotText(root, 'title', T.title);
    setSlotHTML(root, 'kicker', T.kicker);
    setSlotImgSrc(root, 'title_img', T.chip_urls[0], T.title);
    setSlotText(root, 'h_def', T.h_def);
    setSlotText(root, 'chip_1', T.chips[0]);
    setSlotText(root, 'chip_2', T.chips[1]);
    setSlotImgSrc(root, 'chip_1_img', T.chip_urls[0], T.chips[0]);
    setSlotImgSrc(root, 'chip_2_img', T.chip_urls[1], T.chips[1]);
    setSlotHTML(root, 'def_short', T.def_short);
    setSlotHTML(root, 'def_long', T.def_long);
    setSlotText(root, 'h_features', T.h_features);
    setSlotText(root, 'h_questions', T.h_questions);
    setSlotText(root, 'hint_fold', T.hint_fold);
    setSlotText(root, 'hint_fold2', T.hint_fold);
    setSlotText(root, 'h_family', T.h_family);
    setSlotText(root, 'hint_fold3', T.hint_fold);
    setSlotText(root, 'h_wordbuild', T.h_wordbuild);
    setSlotText(root, 'hint_fold4', T.hint_fold);
    renderListInto(root, 'features', T.features);
    renderListInto(root, 'questions', T.questions);
    setSlotHTML(root, 'example_box', T.example_box);
    setSlotHTML(root, 'family_1', T.family_1);
    setSlotHTML(root, 'family_2', T.family_2);
    renderWordBlocks(root, 'wordbuild_blocks', T.word_blocks);
    renderListInto(root, 'wordbuild_notes', T.word_notes);
    setCTA(root, lang);
    setPressed(root, lang);
    protectKeywordsInElement(root);
  }

  function wireButtons(root){
    if (!root || root.__poLangBound) return;
    root.__poLangBound = true;
    var btns = root.querySelectorAll('.po-langbtn');
    for (var i=0;i<btns.length;i++){
      btns[i].addEventListener('click', function(){
        var lang = normLang(this.getAttribute('data-po-lang') || 'fr');
        applyLangEverywhere(lang);
      });
    }
  }

  function lexiconLooksReady(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) return true;
      if (window.PO_LEXICON_MAP) return true;
      if (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length) return true;
    }catch(e){}
    return false;
  }

  /* ====================== AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL ====================== */

  var PO_AUDIO_SYNTH = (typeof window !== 'undefined' && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = { root:null, units:[], unitPos:-1, chunks:[], chunkPos:-1, activeKey:'', lang:'fr', voice:null };
  var AUDIO_UI = {
    fr: { general: 'Écouter le texte', block: 'Écouter ce bloc', stop: 'Arrêter la lecture' },
    en: { general: 'Listen to the text', block: 'Listen to this section', stop: 'Stop playback' },
    es: { general: 'Escuchar el texto', block: 'Escuchar este bloque', stop: 'Detener la lectura' }
  };

  function audioUI(lang){ var L = normLang(lang); return AUDIO_UI[L] || AUDIO_UI.fr; }
  function getAudioRoots(){ return getTargetBlocks(); }
  function getDetailBlocks(root){ return root ? Array.prototype.slice.call(root.querySelectorAll('.po-lex-details') || []) : []; }

  function getTextValue(el){
    if (!el) return '';
    var txt = '';
    try{ txt = el.textContent || el.innerText || ''; }catch(e){ txt = ''; }
    return clampStr(txt).replace(/\s+/g, ' ').trim();
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll('.po-axis-audio-wrap, .po-axis-audio-btn');
    for (var i=0;i<btns.length;i++) if (btns[i] && btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ['title', 'kicker', 'h_def', 'def_short', 'def_long'];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join('. ');
  }

  function collectDetailText(detail){
    if (!detail) return '';
    var parts = [];
    var title = detail.querySelector('.po-lex-summary__title') || detail.querySelector('.po-lex-summary');
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);
    var clone = detail.cloneNode(true);
    var summary = clone.querySelector('.po-lex-summary');
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);
    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);
    return parts.join('. ');
  }

  function splitTextForSpeech(text){
    var raw = clampStr(text).replace(/\s+/g, ' ').trim();
    if (!raw) return [];
    var pieces = raw.match(/[^.!?;:]+[.!?;:]?/g) || [raw];
    var out = [];
    var current = '';
    for (var i=0;i<pieces.length;i++){
      var piece = clampStr(pieces[i]).trim();
      if (!piece) continue;
      if (((current ? current + ' ' : '') + piece).length > 220){
        if (current) out.push(current.trim());
        if (piece.length > 220){
          var words = piece.split(/\s+/);
          var acc = '';
          for (var j=0;j<words.length;j++){
            var w = words[j];
            if (!w) continue;
            var next = acc ? (acc + ' ' + w) : w;
            if (next.length > 220){
              if (acc) out.push(acc.trim());
              acc = w;
            }else acc = next;
          }
          current = acc || '';
        }else current = piece;
      }else current = current ? (current + ' ' + piece) : piece;
    }
    if (current) out.push(current.trim());
    return out;
  }

  function getVoices(){ try{ return PO_AUDIO_SYNTH ? (PO_AUDIO_SYNTH.getVoices() || []) : []; }catch(e){ return []; } }
  function pickVoiceForLang(lang){
    var voices = getVoices();
    if (!voices.length) return null;
    var target = normLang(lang);
    var targets = target === 'fr' ? ['fr', 'fr-fr', 'fr_ca', 'fr-ca'] : target === 'en' ? ['en', 'en-us', 'en-gb'] : ['es', 'es-es', 'es-mx', 'es-us'];
    var i, v, vl;
    for (i=0;i<voices.length;i++){
      v = voices[i];
      vl = clampStr(v.lang).toLowerCase();
      if (targets.indexOf(vl) !== -1) return v;
    }
    for (i=0;i<voices.length;i++){
      v = voices[i];
      vl = clampStr(v.lang).toLowerCase();
      if (vl.indexOf(target) === 0) return v;
    }
    return voices[0] || null;
  }
  function getSpeechLangCode(lang){ var L = normLang(lang); if (L === 'en') return 'en-US'; if (L === 'es') return 'es-ES'; return 'fr-FR'; }

  function ensureAudioStyles(){
    if (document.getElementById('po-axis-audio-styles')) return;
    var style = document.createElement('style');
    style.id = 'po-axis-audio-styles';
    style.textContent =
      '.po-axis-audio-wrap{display:flex;align-items:center;gap:.6rem;margin:1rem 0 1.15rem 0;}' +
      '.po-axis-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid currentColor;background:transparent;color:inherit;padding:.55rem .9rem;border-radius:999px;cursor:pointer;font:inherit;line-height:1.2;transition:opacity .2s ease,transform .2s ease;}' +
      '.po-axis-audio-btn:hover{transform:translateY(-1px);}' +
      '.po-axis-audio-btn[aria-pressed="true"]{font-weight:600;}' +
      '.po-lex-summary .po-axis-audio-btn{margin-left:.75rem;vertical-align:middle;}' +
      '@media (max-width:640px){.po-lex-summary .po-axis-audio-btn{display:block;margin:.65rem 0 0 0;}}';
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-axis-audio-btn';
    btn.setAttribute('data-po-audio-role', role === 'general' ? 'general' : 'detail');
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('translate', 'yes');
    return btn;
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector('.po-lex-panel');
    if (panel){
      var generalWrap = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]');
      if (!generalWrap){
        generalWrap = document.createElement('div');
        generalWrap.className = 'po-axis-audio-wrap';
        generalWrap.setAttribute('data-po-audio-role', 'general');
        var generalBtn = createAudioButton('general');
        generalWrap.appendChild(generalBtn);

        var meta = root.querySelector('.po-axis-meta');
        var defShort = root.querySelector("[data-po-slot='def_short']");
        var firstDetail = panel.querySelector('.po-lex-details');

        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        }else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        }else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        }else panel.appendChild(generalWrap);
      }
    }

    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var detail = details[i];
      var summary = detail.querySelector('.po-lex-summary');
      if (!summary) continue;
      var btn = summary.querySelector('.po-axis-audio-btn[data-po-audio-role="detail"]');
      if (!btn){
        btn = createAudioButton('detail');
        summary.appendChild(btn);
      }
      btn.setAttribute('data-po-audio-index', String(i));
    }
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var ui = audioUI(lang);
    var activeRoot = (PO_AUDIO_STATE.root === root);
    var activeKey = PO_AUDIO_STATE.activeKey;
    var btns = root.querySelectorAll('.po-axis-audio-btn');
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      var role = btn.getAttribute('data-po-audio-role') || 'detail';
      var idx = parseInt(btn.getAttribute('data-po-audio-index'), 10);
      var key = role === 'general' ? 'general' : ('detail:' + (isNaN(idx) ? -1 : idx));
      var isActive = activeRoot && activeKey === key && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending);
      btn.textContent = isActive ? ui.stop : (role === 'general' ? ui.general : ui.block);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
  }

  function openDetailForPlayback(detail){
    if (!detail) return;
    try{ if (typeof detail.open !== 'undefined') detail.open = true; }catch(e){}
    try{ detail.setAttribute('open', 'open'); }catch(_e){}
  }

  function stopAudio(){
    try{ if (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)) PO_AUDIO_SYNTH.cancel(); }catch(e){}
    var roots = getAudioRoots();
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.voice = null;
    PO_AUDIO_STATE.lang = getLang();
    for (var i=0;i<roots.length;i++) refreshAudioLabels(roots[i], getLang());
  }

  function buildUnits(root, role, index){
    var units = [];
    var details = getDetailBlocks(root);
    if (role === 'general'){
      units.push({ role:'general', index:-1 });
      for (var i=0;i<details.length;i++) units.push({ role:'detail', index:i });
      return units;
    }
    var start = (typeof index === 'number' && index >= 0) ? index : 0;
    for (var j=start;j<details.length;j++) units.push({ role:'detail', index:j });
    return units;
  }

  function getTextForUnit(root, unit){
    if (!root || !unit) return '';
    if (unit.role === 'general') return collectGeneralText(root);
    var details = getDetailBlocks(root);
    var detail = details[unit.index];
    if (!detail) return '';
    openDetailForPlayback(detail);
    return collectDetailText(detail);
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.root) return;
    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      playCurrentUnit(true);
      return;
    }
    var chunk = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!chunk){ speakNextChunk(); return; }
    var utter = new SpeechSynthesisUtterance(chunk);
    utter.lang = getSpeechLangCode(PO_AUDIO_STATE.lang);
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;
    utter.rate = 1;
    utter.pitch = 1;
    utter.onend = function(){ speakNextChunk(); };
    utter.onerror = function(){ speakNextChunk(); };
    try{ PO_AUDIO_SYNTH.speak(utter); }catch(e){ speakNextChunk(); }
  }

  function playCurrentUnit(fromNext){
    if (!PO_AUDIO_STATE.root) return;
    if (!fromNext && PO_AUDIO_STATE.unitPos < 0) PO_AUDIO_STATE.unitPos = 0;
    if (fromNext) PO_AUDIO_STATE.unitPos += 1;
    if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){ stopAudio(); return; }
    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    var text = getTextForUnit(PO_AUDIO_STATE.root, unit);
    var chunks = splitTextForSpeech(text);
    if (!chunks.length){ playCurrentUnit(true); return; }
    PO_AUDIO_STATE.chunks = chunks;
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = unit.role === 'general' ? 'general' : ('detail:' + unit.index);
    refreshAudioLabels(PO_AUDIO_STATE.root, PO_AUDIO_STATE.lang);
    speakNextChunk();
  }

  function startAudio(root, role, index){
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio();
    var lang = getLang();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.lang = lang;
    PO_AUDIO_STATE.voice = pickVoiceForLang(lang);
    playCurrentUnit(false);
  }

  function bindAudioButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn');
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn.__poAudioBound) continue;
      btn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = this.getAttribute('data-po-audio-role') || 'detail';
        var index = parseInt(this.getAttribute('data-po-audio-index'), 10);
        var key = role === 'general' ? 'general' : ('detail:' + (isNaN(index) ? -1 : index));
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);
        if (sameRoot && sameKey && (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending))){
          stopAudio();
          return;
        }
        startAudio(root, role, isNaN(index) ? -1 : index);
      });
      btn.__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === 'function'){
      PO_AUDIO_SYNTH.addEventListener('voiceschanged', function(){
        if (PO_AUDIO_STATE.root) PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang || getLang());
      });
    }
  }catch(e){}

  function applyLangEverywhere(lang){
    lang = normLang(lang);
    storeLang(lang);
    var roots = getTargetBlocks();
    for (var i=0;i<roots.length;i++){
      renderRoot(roots[i], lang);
      wireButtons(roots[i]);
    }
    initAudioEverywhere(lang);
    notifyLocaleChanged();
  }

  function init(){
    applyLangEverywhere(getLang());
    window.addEventListener('po:lexicon-ready', function(){
      __PO_PROTECT_CACHE__.key = '';
      __PO_PROTECT_CACHE__.re = null;
      applyLangEverywhere(getLang());
    });
    if (!lexiconLooksReady()){
      var tries = 0;
      var maxTries = 80;
      var timer = setInterval(function(){
        tries++;
        if (lexiconLooksReady() || tries >= maxTries){
          clearInterval(timer);
          __PO_PROTECT_CACHE__.key = '';
          __PO_PROTECT_CACHE__.re = null;
          applyLangEverywhere(getLang());
        }
      }, 100);
    }
  }

  window.PoKatupirsia9MoisPosoennoiauxTextsFR_EN_ES_20260327 = {
    init: init,
    setLang: applyLangEverywhere,
    getLang: getLang,
    normLang: normLang,
    stopAudio: stopAudio
  };

  try{
    if (!window.GoodyTwinLang){
      window.GoodyTwinLang = { init:init, getLang:getLang, setLang:applyLangEverywhere };
    }else{
      if (typeof window.GoodyTwinLang.getLang !== 'function') window.GoodyTwinLang.getLang = getLang;
      if (typeof window.GoodyTwinLang.setLang !== 'function') window.GoodyTwinLang.setLang = applyLangEverywhere;
      if (typeof window.GoodyTwinLang.init !== 'function') window.GoodyTwinLang.init = init;
    }
  }catch(e){}

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
